import React from 'react'
import Link from 'gatsby-link'
import { fonts, colors } from '../../themes'
import places from 'lib/places'

const styles = {
  link: {
    color: colors.white,
    textDecoration: 'none',
    ':hover': {
      color: colors.mainBlue,
      textDecoration: 'none',
    },
    ':active': {
      color: colors.mainBlue,
      textDecoration: 'none',
    },
    ':focus': {
      color: colors.mainBlue,
      textDecoration: 'none',
    },
  },
}

const LocationLinks = () => {
  const createLink = (place, keyword) => {
    return encodeURI(`/${keyword}_moonlighting_jobs_in/${place.city},${place.state}/`)
  }

  const links = places.map(place => (
    <div>
      <Link
        css={styles.link}
        to={createLink(place, 'doctor')}
      >
        Doctor Moonlighting jobs in {place.city}, {place.state}
      </Link>
      <Link
        css={styles.link}
        to={createLink(place, 'physician')}
      >
        Physician Moonlighting jobs in {place.city}, {place.state}
      </Link>
      <Link
        css={styles.link}
        to={createLink(place, 'resident')}
      >
        Resident Moonlighting jobs in {place.city}, {place.state}
      </Link>
    </div>
  ))

  return (
    <div css={{ overflow: 'scroll', height: 1, width: 1}}>
      {links}
    </div>
  )
}
  
export default LocationLinks





// WEBPACK FOOTER //
// ./src/components/base/locationLinks.js